module.exports = __webpack_public_path__ + "static/media/performance_0006.6adbff8a.JPG";